export default {
	login: {
		salesBackend: "OMELink 銷售後台登陸",
		account: "賬號",
		password: "密碼",
		login: "登錄",
		loggingIn: "登錄中...",
		pleaseEnter: "請輸入",
		userName: "用戶名",
		loginSuccessful: "登錄成功",
		loginFailed: "登錄失敗，請檢查賬號和密碼",
		usingOa: "使用OA賬號登錄",
		usingSjfood: "使用HiFood賬號登錄",
		and: "和",
	},
	index: {
		customerSettings: "客戶設置",
		personalInformation: "個人資料",
		logOut: "退出登錄",
		selectLanguage: "選擇語言",
		confirmExit: "確認退出嗎?",
		hint: "提示",
		productSettings: "商品設置",
		syncSettings: "同步設置",
		customerBinding: "客戶綁定",
	},
	personal: {
		avatar: "頭像",
		nickName: "昵稱",
	},
	operator: {
		addTo: "添加",
		authorizer: "授權人",
		permissions: "權限",
		startingTime: "開始時間",
		endTime: "結束時間",
		revise: "修改",
		delete: "刪除",
		viewPermissions: "查看權限,發送權限",
	},
	customer: {
		customerCode: "客戶編碼",
		customerName: "客戶名稱",
		warehouse: "貨倉",
		customerBindingQuantity: "客戶綁定數量",
		maintenanceQuantity: "物料變動維護數量",
		operate: "操作",
		customerBinding: "客戶綁定",
		productSettings: "商品設置",
		batchOpertion: "批量维护",
		selectCustomer: "选择客户",
		importItem: "导入Item",
		batchImportItem: "批量导入Item",
		successfully: "完成",
		previousStep: "上一步",
		nextStep: "下一步",
		selectFile: "选择文件",
		templateDownload: "模版下载",
		noFileSelected: "未选择任何文件",
		downloadingTemplate: "模版下载成功",
		operationSuccess: "批量维护成功",
		aTotalOf: "共",
		errorTips: "個商品系統檢測有ID错误，導入失敗！請檢查後再導入。",
		importSuccessfully: "導入成功",
	},
	customerProduct: {
		myClient: "我的客戶",
		productSettings: "商品設置",
		specification: "規格",
		editedSuccessfully: "編輯成功!",
	},
	customerProductLastest: {
		myClient: "我的客戶",
		productSettings: "商品設置",
		syncSettings: "同步設置",
		changeUpdates: "檢查商品變動更新",
		old: "舊",
		new: "新",
		state: "狀態",
		waitingForConfirmation: "等待確認",
		applied: "已應用",
		notApplied: "未應用",
		operate: "操作",
		newAdditions: "新增",
		renew: "更新",
		time: "時間",
		SALESConfirmed: "SALES確認",
		application: "應用",
		notApplied: "不應用",
		successfulOperation: "操作成功!",
	},
	customerPhone: {
		myClient: "我的客戶",
		customerBinding: "客戶綁定",
		addBinding: "添加綁定",
		noData: "暫無數據，請添加",
		telephoneNumber: "電話號碼",
		remarkName: "備注名",
		memorandum: "備忘錄",
		smsDisable: "禁用SMS",
		operate: "操作",
		edit: "編輯",
		unbind: "解除綁定",
		CRMContact: "請選擇CRM聯系人",
		enterANote: "請輸入備忘",
		editBinding: "編輯綁定",
		correctPhoneNumber: "請輸入正確格式的電話號碼",
		ContentIsTooLong: "請輸入備忘錄",
		bindingSuccessfully: "添加綁定成功!",
		errorMessage: "填寫信息存在錯誤!",
		successfulOperation: "操作成功!",
		setupSuccessful: "設置成功!",
		closedSuccessfully: "關閉成功!",
		unbindHint: "是否確定進行解除綁定操作?",
		hint: "提示",
		UnbindingSuccessful: "解除綁定成功!",
		numberIdentityNote: "號碼身份備注",
		selectIdentityNote: "請選擇身份備注",
		customRemarks: "自定義號碼身份備注",
		pleaseEnterCustomRemarks: "請輸入自定義號碼身份備注",
		manager: "經理",
		boss: "老板",
		headChef: "廚師長",
		accountant: "會計",
		custom: "自定義",
		phoneEditDelateGuid: "無法操作來源於CRM的聯系人，請到CRM上進行操作。",
        billManagement: "账单管理",
        add: "新增",
		},
	productSpecification: {
		addTo: "添加",
		nameSearch: "請輸入規格名稱搜索",
		specificationName: "規格名稱",
		operate: "操作",
		edit: "編輯",
		editSpecifications: "編輯規格",
		attributes: "屬性",
		addAttributes: "請添加屬性",
		name: "名稱",
		optionName: "請輸入option名稱",
		enterSpecificationName: "請輸入規格名稱!",
		addOptions: "請添加options!",
		editedSuccessfully: "編輯成功!",
		errorMessage: "填寫信息存在錯誤!",
		enterAttributeName: "請輸入屬性名稱",
		sureDelete: "是否確定進行刪除操作?",
		hint: "提示",
		successfullyDeleted: "刪除成功!",
		cannotSortWhenSearching: "搜索時無法排序",
		sortingSaveFail: "排序失敗",
		sortingSaveSuccess: "排序成功",
	},
	productHistory: {
		materialChange: "物料變動維護",
		aliasSearch: "請輸入商品名稱或別名搜索",
		noData: "暫無數據",
		productName: "商品名稱",
		productAlias: "商品別名",
		category: "類別",
		state: "狀態",
		enable: "啟用",
		disable: "停用",
		operate: "操作",
		edit: "編輯",
		codingImportGoods: "按客戶編碼導入商品",
		importProducts: "導入商品",
		enterCustomerCode: "輸入客戶編碼",
		selectProduct: "選擇商品",
		finish: "完成",
		customerCode: "客戶編碼",
		nextStep: "下一步",
		cancelSelection: "取消選擇",
		previous: "上一步",
		import: "導入",
		aTotalOf: "共",
		productImportSuccess: "個商品導入成功!",
		productImportFailure: "個商品系統檢測有重複，導入失敗！請檢查後再導入。",
		pleaseEnterCustomerCode: "請輸入客戶編碼!",
		messageInformationCorrectly: "請正確填寫信息!",
		pleaseSelectProduct: "請選擇要導入的商品信息!",
	},
	productEdit: {
		editProductInformation: "編輯商品信息",
		basicInformation: "基本資料",
		productName: "商品名稱",
		productAlias: "商品別名",
		category: "類別",
		state: "狀態",
		enable: "啟用",
		disable: "停用",
		specificationInformation: "規格信息",
		selectSpecifications: "選擇規格",
		deleteSpecification: "刪除規格",
		enterSpecificationName: "請輸入規格名稱",
		addSpecs: "添加規格",
		pleaseChoose: "請選擇",
		attributes: "屬性",
	},
	productAll: {
		aliasSearch: "請輸入商品名稱或別名搜索",
		noData: "暫無數據",
		productName: "商品名稱",
		productAlias: "商品別名",
		category: "類別",
		state: "狀態",
		enable: "啟用",
		disable: "停用",
		operate: "操作",
		edit: "編輯",
		insert: "插入",
		insertingSuccessfully: "插入history成功!",
	},
	avatar: {
		setAvatar: "設置頭像",
		preview: "預覽",
		changePicture: "更換圖片",
		enlarge: "放大",
		zoomOut: "縮小",
		rotateLeft: "左旋轉",
		rotateRight: "右旋轉",
		upload: "上傳",
		errorGetAvatar: "獲取頭像失敗，請稍後再嘗試",
		sizeCannotExceed: "上傳頭像圖片大小不能超過 2MB!",
		selectPicture: "請選擇圖片",
		setupSuccessful: "設置成功",
		uploadFailed: "上傳失敗，請稍後再嘗試",
	},
	addSpecification: {
		addSpecs: "添加規格",
		specificationName: "規格名稱",
		attributes: "屬性",
		addAttributes: "請添加屬性",
		addTo: "添加",
		name: "名稱",
		operate: "操作",
		delete: "刪除",
		addProperties: "添加屬性",
		enterAttributeName: "請輸入屬性名稱",
		enterSpecificationName: "請輸入規格名稱!",
		addOptions: "請添加options!",
		addedSuccessfully: "添加成功!",
		errorMessage: "填寫信息存在錯誤!",
	},
	chatEmojiPicker: {
		recent: "最近使用",
		people: "人物",
		nature: "動物",
		foods: "食物",
		activity: "運動",
		places: "地方",
		objects: "對象",
		symbols: "符號",
		flags: "旗幟",
	},
	chatHistoryMessage: {
		viewContext: "查看上下文",
		copy: "復制",
		save: "保存",
		copiedToClipboard: "已復制到剪貼板",
		copyFailed: "復制失敗",
		errorTextMessage: "暫時只支持文本消息復制",
		errorMessage: "暫時只支持語音消息保存",
	},
	chatHistory: {
		enterChatContent: "請輸入聊天內容",
		back: "返回",
	},
	chatMessageCheckDetails: {
		serialNumber: "編號",
		amount: "金額",
		uploadDate: "上傳日期",
		frontPicture: "支票正面圖片",
		reversePicture: "支票反面圖片",
		supplier: "供應商",
		userAmount: "用戶輸入金額",
		checkStatus: "支票狀態",
	},
	chatMessageCheck: {
		checkUploadReminder: "支票上傳提醒",
		checkCheckUpload: "檢查支票上傳",
		checkDetails: "支票詳情",
	},
	chatMessageNonsupport: {
		versionIsTooLow: "你的版本過低 無法查看此內容",
	},
	chatMessageOrder: {
		orderDetails: "訂單詳情",
		order: "訂單",
		deliveryDate: "交付日期",
		productsOrdered: "已訂購產品",
		productsInclude: "包含產品",
		viewOrder: "查看訂單",
	},
	chatMessageReadStatus: {
		haveRead: "已讀",
		unread: "未讀",
		readingStatus: "閱讀狀態",
	},
	chatMessageStatus: {
		resendThisMessage: "是否重新發送該條信息",
		hint: "提示",
	},
	chatMessageText: {
		translateText: "翻譯文本",
	},
	chatMessageVoice: {
		voiceIsCorrupted: "語音已損壞",
	},
	chatMessages: {
		retractedMessage: "你撤回了一條消息",
		copy: "復制",
		save: "保存",
		recall: "撤回",
		concealTranslated: "隱藏翻譯",
		translated: "翻譯",
		copiedToClipboard: "已復制到剪貼板",
		copyFailed: "復制失敗",
		supportsTextMessages: "暫時只支持文本消息復制",
		supportsTextVoice: "暫時只支持語音消息保存",
		supportsTexttranslated: "暫時只支持文本翻譯",
	},
	chatPicturePaster: {
		sendThisImage: "是否發送該圖片？",
		send: "發送",
	},
	chatRecorder: {
		recording: "錄音",
		stop: "停止",
		send: "發送",
		recordingFailed: "錄音失敗",
		timeShort: "說話時間太短了",
		timeLong: "說話時間過長",
		microphonePermissionDenied: "錄音失敗，請允許訪問麥克風的權限",
	},
	contactList: {
		remarkName: "備注名:",
	},
	contacts: {
		contactPerson: "聯系人",
	},
	conversationList: {
		recentChat: "最近聊天",
		remarkName: "備注名:",
		cancelStick: "取消置頂",
		haveRead: "已讀",
		unread: "未讀",
		stick: "置頂",
		pinnedSuccessfully: "置頂成功!",
		unpinnedSuccessfully: "取消置頂成功!",
	},
	detailContact: {
		chatInformation: "聊天信息",
		METISusageCount: "METIS使用次數：",
		leftOver: "還剩",
		strip: "條",
		nickName: "昵稱",
		remarkName: "備注名",
		revise: "修改",
		associatedCustomers: "關聯客戶",
		none: "無",
		smartResponse: "METIS智能應答客服",
		open: "開",
		close: "關",
		automaticTranslation: "自動翻譯",
		setupSuccessful: "設置成功!",
		enterRemarks: "請輸入備注",
		hint: "提示",
		yes: "是",
		no: "否",
		phoneNumber: "手機號",
		openTip1: "PST 13:30 - 次日 PST 01:00",
		openTip2: "在這個時間段內，識別到客人問題的意圖為已掌握的問題時，METIS正常回覆。",
		openTip3: "在這個時間段內，識別到客人問題的意圖為未掌握的問題時，METIS不回覆。",
		userDoesNotBelong: "當前用戶不是你的聯絡人",
	},
	detailGroup: {
		groupInformation: "群組信息",
		groupChatName: "群聊名稱:",
		modifyGroupName: "修改群名",
		addMember: "添加成員",
		noData: "暫無數據，請添加",
		avatar: "頭像",
		nickName: "昵稱",
		groupNotes: "群組備注",
		operate: "操作",
		editorNotes: "編輯備注",
		removeMember: "移除成員",
		userDoesNotBelong: "當前用戶不屬於該群！",
		enterTheCommentName: "請輸入成員備注名",
		hint: "提示",
		selectMembers: "請選擇成員",
		pleaseEnterTheGroupChatName: "請輸入群聊名稱",
		groupNameHasNotChanged: "群組名字沒有改變!",
		groupNameCannotBeEmpty: "群組名字不能為空!",
		confirmToRemoveMember: "確定要移除成員嗎?",
	},
	groupList: {
		groupChat: "群聊",
		createGroupChat: "創建群聊",
		groupName: "群名稱:",
	},
	selectMember: {
		selectMembers: "選擇成員",
		chosen: "已選擇:",
		contactPerson: "聯系人",
		salesperson: "銷售人員",
		groupChat: "的群聊",
		atLeast: "最少要3個群聊成員",
	},
	chat: {
		realTimeServer: "即時服務器連接失敗，正在連接中...",
		enterSearchContent: "請輸入搜索內容",
		recentChat: "最近聊天",
		addressBook: "通訊錄",
		groupChat: "群聊",
		chatRecord: "聊天記錄",
		selectLanguage: "請選擇語言",
		ctrlEnter: "按Ctrl + Enter發送消息",
		commandEnter: "按Command + Enter發送消息",
		enter: "按Enter發送消息",
		translateContent: "翻譯內容",
		send: "發送",
		imageUploadFailed: "圖片上傳失敗，請重新嘗試",
		onlyWithdrawMessages: "只能撤回自己發送的消息",
		fileError: "无法读取视频文件信息！",
		loadFailed: "加载失败，点击重试",
		loading: "加载中...",
		fileErrorTip: "發送失敗，文件格式支持圖片或mp4、文件大小不超過300M、文件時長不能超過 30 分鐘",
		aFile: "个文件",
		errorTip: "文件上傳失敗，無法重新發送，請重新選擇文件上傳。",
	},
	messageJS: {
		voice: "[語音]",
		picture: "[圖片]",
	},
	storeIndexJS: {
		have: "有",
		unreadMessages: "條未讀消息",
		haveNewMessage: "你有一條新消息",
	},
	apiJS: {
		loginHasExpired: "登錄已過期，是否重新登錄?",
		hint: "提示",
		unknownMistake: "未知錯誤",
	},
	router: {
		login: "登陸",
		customerCommunication: "客戶溝通",
		setup: "設置",
		myClient: "我的客戶",
		customerBinding: "客戶綁定",
		productSettings: "商品設置",
		syncSettings: "同步設置",
		personalInformation: "個人資料",
		authorizationSettings: "授權設置",
		messageSending: "短信發送",
		aiEmail: "AI EMAIL设置",
		openClawManagement: "數字員工管理",
		omelinkUserServiceMaintenance: "OMELINK用戶服務維護",
	},
	dateJS: {
		today: "今天",
	},
	common: {
		cancel: "取消",
		confirm: "確認",
		sure: "確定",
		delete: "刪除",
		options: "選項",
		option: "選項",
		history: "歷史",
		all: "全部",
		setup: "設定",
	},
	chatMessageOrderDetails: {
		supplier: "供應商",
		orderBy: "訂購者",
		billTo: "收款方",
		shipTo: "收貨方",
		deliveryDate: "交貨日期",
		comment: "備註",
		ordered: "已訂購",
		include: "包含",
		orderDetails: "訂單詳情",
	},
	generalization: {
		listTitle: "推廣列表",
		searchPlaceholder: "搜索",
		checkOut: "查看",
		sendAgain: "再次發送",
		send: "一鍵發送",
		detailTitle: "推廣詳情",
		isSendMessage: "将信息發送給",
	},
	messageSending: {
		title: "未註冊 OMELINK 的客戶",
		customerName: "客人名稱",
		customerPhone: "客人電話",
		associatedRestaurantId: "關聯餐廳ID",
		restaurantName: "餐廳名稱",
		operate: "操作",
		historyRecord: "歷史記錄",
		sendMessage: "發送短信",
		cancel: "取消",
		confirm: "確認發送",
		restaurantId: "餐廳ID",
		close: "關閉",
		orderId: "訂單ID",
		snedText: "發送內容",
		sendTime: "發送時間",
		sendSuccess: "發送成功",
		isCheckedDocument: "是否查看单据",
		isDownLoad: "是否下載 OMELINK",
		sendDocument: "發送单据",
		true: "是",
		false: "否",
		check: "查看",
	},
	aiEmail: {
		account: "郵箱帳號",
		accountDescription: "配置用於接收和處理 AI 訂單郵件的郵箱。",
		configureAccount: "配置郵箱",
		editAccount: "編輯郵箱",
		emailAddress: "郵箱地址",
		emailPassword: "郵箱密碼",
		passwordSetHint: "已設置密碼，留空則保持不變。",
		accountEnabled: "啟用郵箱處理",
		enabled: "已啟用",
		disabled: "已停用",
		syncError: "同步異常",
		latestSync: "最近同步時間",
		noSyncTime: "暫無",
		accountEmpty: "尚未配置郵箱。請先保存郵箱帳號和密碼。",
		emailDisabledNotice: "當前郵箱已停用，不會同步或處理郵件；仍可維護聯絡人。",
		contacts: "郵件聯絡人",
		contactsDescription: "只有已配置的聯絡人發來的下單郵件會由 AI 處理。",
		addContact: "新增聯絡人",
		editContact: "編輯聯絡人",
		guestEmail: "客人郵箱",
		processingMode: "處理模式",
		automatic: "全自動",
		semiAutomatic: "半自動",
		automaticDescription: "AI 將以英文回覆客人，並在資訊完整後下單。",
		semiAutomaticDescription: "AI 靜默識別下單意圖，資訊完整後直接下單且不回覆客人。",
		associatedCustomers: "关联客户",
		updatedAt: "更新時間",
		actions: "操作",
		edit: "編輯",
		delete: "刪除",
		customerPlaceholder: "請選擇 Customer",
		noCustomers: "當前銷售名下沒有可用 Customer。",
		loadingAccount: "正在載入郵箱設定...",
		loadingContacts: "正在載入聯絡人...",
		validatingConnection: "正在驗證郵箱連接...",
		save: "保存",
		accountSaveSuccess: "郵箱設定已保存。",
		statusUpdateSuccess: "郵箱狀態已更新。",
		contactCreateSuccess: "聯絡人已新增。",
		contactUpdateSuccess: "聯絡人已更新。",
		contactDeleteSuccess: "聯絡人已刪除。",
		validationEmail: "請輸入正確的郵箱地址。",
		validationPassword: "首次保存時必須輸入郵箱密碼。",
		validationMode: "請選擇處理模式。",
		validationCustomers: "請至少選擇一個 Customer。",
		confirmDelete: "確認刪除",
		deleteContactMessage: "刪除後，系統將不再處理來自 {email} 的新郵件。確認刪除嗎？",
	},
	serviceMaintenance: {
		userList: "用戶列表",
		serviceProviderList: "服務商列表",
		customerName: "客人名稱",
		customerPhone: "客人電話",
		associatedRestaurantId: "關聯餐廳ID",
		restaurantName: "餐廳名稱",
		operate: "操作",
		serviceMaintenance: "服務商維護",
		batchMaintenance: "批量維護服務商",
		sort: "序號",
		applicationName: "應用名稱",
		type: "類別",
		status: "狀態",
		selectUsers: "選擇用戶",
		selectServiceProvider: "選擇服務商",
		complete: "完成",
		nextStep: "下一步",
		previous: "上一步",
		selectServiceProviderTip: "選擇需要展示的服務商（不選的服務商設置爲屏蔽）",
		batchMaintenanceComplete: "批量維護完成",
		latestShelvesTime: "最新上架時間",
		introduction: "商戶介紹",
		businessName: "商戶名稱",
		show: "顯示",
		hide: "屏蔽",
		soft: "軟件",
		service: "服務",
		successfulOperation: "操作成功!",
	},
	openClawManagement: {
		guestName: "客人名稱",
		guestPhoneNumber: "客人電話",
		associatedRestaurantId: "關聯餐廳ID",
		restaurantName: "餐廳名稱",
		status: "數字員工狀態",
		operate: "操作",
		show: "顯示",
		hide: "屏蔽",
		noData: "暫無數據",
		loading: "加载中...",
		updateSuccess: "操作成功!",
	},
};
